module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/store_images/1_ac751538dbf47c700e660a813aad4206.jpg";